import AbstractManageable from "./abstract-manageable"
import User               from "./user"
import LocalAuthority from "./local-authority";

export default class Demography extends AbstractManageable {

	/**
	 *
	 * @param {LocalAuthority} localAuthority
	 * @param {Number} year
	 * @param {Number} population
	 * @param {User}   creator
	 * @param {Date}   createdAt
	 * @param {User}   updater
	 * @param {Date}   updatedAt
	 */
	constructor(
		localAuthority,
		year,
		population,
		creator,
		createdAt,
		updater,
		updatedAt
	) {
		super(creator, createdAt, updater, updatedAt)

		this.localAuthority = localAuthority
		this.year           = year
		this.population     = population
	}

	static createFromJson = (json) => {
		if (!json) return null

		return new Demography(
			LocalAuthority.createFromJson(json),
			json.year,
			json.population,
			User.createFromJson(json.creator),
			new Date(json.createdAt),
			User.createFromJson(json.updater),
			new Date(json.updatedAt)
		)
	}

}


// WEBPACK FOOTER //
// ./src/model/demography.js